module.exports = __webpack_public_path__ + "static/media/video.a2a8d0b8.svg";